import { environmentHttpClient } from "client/Api/httpClient";

export function hasResource(
	appId: number,
	signal?: AbortSignal
): Promise<boolean> {
	return environmentHttpClient.get<boolean>(
		`Workspace/WindowsVirtualDesktop/HasResource/${appId}`,
		undefined,
		{ signal }
	);
};
